import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { required } from "ra-core";
import { DateTimeInput } from "@/components/admin";

import { contactOptionText } from "../misc/ContactOption";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { AutocompleteCompanyInput } from "../companies/AutocompleteCompanyInput";

const priorities = [
  { id: "low", name: "Baja" },
  { id: "medium", name: "Media" },
  { id: "high", name: "Alta" },
  { id: "urgent", name: "Urgente" },
];

const statuses = [
  { id: "pending", name: "Pendiente" },
  { id: "in_progress", name: "En progreso" },
  { id: "completed", name: "Completada" },
  { id: "cancelled", name: "Cancelada" },
];

export const TaskFormContent = ({
  selectContact,
}: {
  selectContact?: boolean;
}) => {
  const { taskTypes } = useConfigurationContext();
  return (
    <div className="flex flex-col gap-4">
      <TextInput
        autoFocus
        source="text"
        validate={required()}
        multiline
        className="m-0"
        helperText={false}
      />
      {selectContact ? (
        <ReferenceInput source="contact_id" reference="contacts_summary">
          <AutocompleteInput
            label="resources.tasks.fields.contact_id"
            optionText={contactOptionText}
            helperText={false}
            modal
          />
        </ReferenceInput>
      ) : null}
      <SelectInput
        source="type"
        validate={required()}
        choices={taskTypes}
        optionText="label"
        optionValue="value"
        defaultValue="follow-up"
        helperText={false}
      />
      <DateTimeInput
        source="due_date"
        helperText={false}
        validate={required()}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ReferenceInput source="company_id" reference="companies">
          <AutocompleteCompanyInput label="resources.tasks.fields.company_id" />
        </ReferenceInput>
        <ReferenceInput source="deal_id" reference="deals">
          <AutocompleteInput
            label="resources.tasks.fields.deal_id"
            optionText="name"
            helperText={false}
          />
        </ReferenceInput>
        <SelectInput
          source="priority"
          choices={priorities}
          defaultValue="medium"
          helperText={false}
        />
        <SelectInput
          source="status"
          choices={statuses}
          defaultValue="pending"
          helperText={false}
        />
      </div>
    </div>
  );
};
